<template>
  <div class="standing">
    <div class="lading_conter_search" id="lading_conter_search-carStatistics">
      <my-search-query ref="queryList" :fromList="fromList" :isShow="true" @queryEven="getTableParams"/>
    </div>
    <div class="lading_conter">
      <div class="lading_table">
        <div class="lading_conter_table">
          <sp-table
            ref="spTable"
            :parentTableData.sync="tableData"
            :parentCol.sync="tableDataCol"
            :dragDrop="true"
            :row-class-name="tableRowClassName"
            height="100%">
            <el-table-column align="center" type="selection" class="selection"></el-table-column>
            <el-table-column align="center" type="index" width="50" label="序号" class-name="index"></el-table-column>
            <sp-table-column :align="item.titleAlignment" v-for="(item, index) in tableDataCol" :key="index"
                             :width="item.displayWidth"
                             sortable
                             :prop="tableDataCol[index].fieldName"
            >
              <template slot="header">
                <p>{{item.fieldAlias}}</p>
              </template>
              <template v-slot="{ scope }">
                <div class="span" :style="{textAlign: item.alignment}">
                  {{scope.row[tableDataCol[index].fieldName]}}
                </div>
              </template>
            </sp-table-column>
          </sp-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex';
  import {spTable, spTableColumn} from '@/components/sptable';
  import mySearchQuery from '../comm/searchQuery';
  import dayjs from 'dayjs';

  const _ = require('lodash');

  export default {
    name: 'adminCarStatistics',
    components: {
      spTable,
      spTableColumn,
      mySearchQuery,
    },
    data() {
      return {
        tableData: [],
        heightSearch: 0,
        bargain: [],
        getOutCarTankList: [],
        getTGuestNumList: [],
        getRefGoodsList: [],
        formInline: {},
        tableDataCol: [],
        getBlno: [],
      };
    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
        listInOutCarAction: 'dictionary/listInOutCarAction',
      }),
      fromList() {
        let arr = [
          // { label: '订单号', key: 'mainOrderId', type: 'input' },
          // { label: '收货单位编号', key: 'GuestID', type: 'input' },
          // { label: '合同号', key: 'BargainID', type: 'input', showDialog: true, tips: '...', dialog: 'showBargainID', code: 3052, },
          {
            label: '罐号',
            key: 'tankId',
            type: 'select',
            showDialog: true,
            tips: '...',
            dialog: 'showGoodsID',
            valData: this.getOutCarTankList,
            labelVal: 'TankID',
            value: 'TankID',
            multiple: false,
            colSpan: 8
          },
          {
            label: '产品',
            key: 'goodsId',
            type: 'select',
            showDialog: true,
            tips: '...',
            dialog: 'showGoodsID',
            valData: this.getRefGoodsList,
            labelVal: 'Name',
            value: 'GoodsID',
            multiple: false,
            colSpan: 8
          },
          {label: '车号', key: 'carNo', type: 'input', colSpan: 8},
          {
            label: '提单号',
            key: 'blno',
            valData: this.getBlno,
            type: 'input',
            labelVal: 'BLNO',
            value: 'BLNO',
            colSpan: 8
          },
          {
            label: '提货人',
            key: 'tGuestId',
            valData: this.getTGuestNumList,
            type: 'select',
            tips: '...',
            dialog: 'showgetTGuest2',
            labelVal: 'Name',
            value: 'GuestID',
            code: 4000,
            colSpan: 8
          },
          // { label: '提货人名称', key: 'Name', type: 'input' },
          // { label: '产品名称', key: 'goodsName', type: 'input' },
          {
            label: '开始时间',
            key: 'beginDate',
            type: 'timeSelect',
            default: `${this.$utils.getTimeByDay(new Date())} 00:00:01`,
            colSpan: 8
          },
          {
            label: '结束时间',
            key: 'endDate',
            type: 'timeSelect',
            default: `${this.$utils.getTimeByDay(new Date())} 23:59:59`,
            colSpan: 8
          },
        ];
        return arr;
      },
    },
    created() {
      this.getOutCarTankAPI();
      this.getRefGoodsAPI();
      this.getTGuestNum();
      this.getlistInOutCarAction();
    },
    mounted() {
      // this.getTableParams(false);
    },
    methods: {
      initColor(item) {
        const Type = {
          1: '#0000FF',
        };
        // if (Type[item.Type]) return Type[item.Type];
        return '#333'
      },
      tableRowClassName({row, rowIndex}) {
        if (row.TankID === '总计') {
          return 'sum'
        }
        if (row.TankID === '小计') {
          return 'subtotal'
        }
        if (row.TankID === '累计') {
          return 'accumulative'
        }

        return ''
      },
      ...mapActions({
        getlistInOutCarAction: 'dictionary/getlistInOutCarAction',
      }),
      licenseNumberSelectionChange() {

      },
      // 台帐参数处理
      getTableParams(start) {
        let params = {
          accountId: this.userInfor.accountId,
          beginDate: '2019-01-01 00:00:00',
          endDate: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
        };
        if (!start) {
          let fromData = _.cloneDeep(this.$refs.queryList.fromData);
          if (fromData.TankID) {
            fromData.tankId = fromData.TankID;
            delete fromData.TankID;
          }
          // if (!fromData.goodsName) fromData.goodsId = '';
          for (let i in fromData) {
            if (i === 'tGuestId') {
              fromData.GuestId = fromData.tGuestId
              delete fromData[i];
            }
            if (!fromData[i] || typeof fromData[i] === 'object') {
              delete fromData[i];
            }
          }
          Object.assign(params, fromData);
        }
        delete params.Name;
        delete params.goodsName;
        this.listAccountBooksAPI(params);
      },
      listAccountBooksAPI(params) {
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'listInOutCar',
          params,
        }).then(res => {
          this.tableData = res.bean;
          this.$refs.spTable.initTable();
        });
      },
      // 产品弹出选择
      getRefGoodsAPI() {
        let params = {
          accountId: this.userInfor.accountId,
          // bargainId: this.formInline.BargainID,
          // goodsId: this.formInline.GoodsID
        };
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'getRefGoods',
          params
        }).then(res => {
          this.getRefGoodsList = res.bean;
        });
      },
      // 提货人编号
      getTGuestNum() {
        let params = {
          accountId: this.userInfor.accountId
        };
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'getTGuest',
          params
        }).then(res => {
          this.getTGuestNumList = res.bean;
        });
      },
      // 罐号选择
      getOutCarTankAPI() {
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'getTank',
          params: {
            accountId: this.userInfor.accountId
          }
        }).then(res => {
          this.getOutCarTankList = res.bean;
        });
      },
      addColData(callback) {
        this.licenseNumberList.push(JSON.parse(JSON.stringify(
          Object.assign(this.licenseNumberOriginData, {
            uid: this.$utils.getUid(),
            id: this.licenseNumberList.length + 1
          })
        )));
        this.$nextTick(() => {
          if (typeof callback === 'function') callback();
        });
      },
      initCol() {
        this.listInOutCarAction.length > 0
        && (this.tableDataCol = this.listInOutCarAction.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            return info;
          })
        );
      },
    },
    watch: {
      listInOutCarAction() {
        this.initCol();
      },
      tableDataCol(val) {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
    }
  };
</script>
<style lang="scss">
  .standing {
    flex: 1;
    display: flex;
    flex-direction: column;
    .sum {
      background-color: rgba(254, 240, 240, 1);
      color: #F56C6C !important;
    }
    .accumulative {
      background-color: rgba(253, 246, 236, 1);
      color: #E6A23C !important;
    }
    .subtotal {
      background-color: rgba(240, 249, 235, 1);
      color: #67C23A !important;
    }
  }
</style>
